
import React from 'react';

const CommunitySection: React.FC = () => {
  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-6">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-4xl font-bold text-center mb-16 text-gray-800">
            地域とのつながり
          </h2>
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div className="space-y-6">
              <p className="text-lg leading-relaxed text-gray-700">
                地域のイベントや防災活動への協力、地元学校との取り組みなどを通じて、
                住みやすい街づくりに貢献しています。
              </p>
              <p className="text-lg leading-relaxed text-gray-700">
                私たちは単なる不動産会社ではなく、地域コミュニティの一員として、
                街の発展と住民の皆様の豊かな暮らしをサポートしています。
              </p>
              <div className="grid grid-cols-2 gap-4 mt-8">
                <div className="bg-blue-50 p-4 rounded-lg text-center">
                  <i className="ri-community-line text-3xl text-blue-600 mb-2"></i>
                  <h4 className="font-semibold text-gray-800">地域清掃活動</h4>
                  <p className="text-sm text-gray-600">月1回実施</p>
                </div>
                <div className="bg-blue-50 p-4 rounded-lg text-center">
                  <i className="ri-shield-check-line text-3xl text-blue-600 mb-2"></i>
                  <h4 className="font-semibold text-gray-800">防災訓練協力</h4>
                  <p className="text-sm text-gray-600">年2回参加</p>
                </div>
                <div className="bg-blue-50 p-4 rounded-lg text-center">
                  <i className="ri-graduation-cap-line text-3xl text-blue-600 mb-2"></i>
                  <h4 className="font-semibold text-gray-800">教育支援</h4>
                  <p className="text-sm text-gray-600">地元学校連携</p>
                </div>
                <div className="bg-blue-50 p-4 rounded-lg text-center">
                  <i className="ri-calendar-event-line text-3xl text-blue-600 mb-2"></i>
                  <h4 className="font-semibold text-gray-800">地域イベント</h4>
                  <p className="text-sm text-gray-600">祭り・催事協賛</p>
                </div>
              </div>
            </div>
            <div className="grid grid-cols-2 gap-4">
              <img 
                src="https://public.readdy.ai/ai/img_res/0b240802e1a8dd67249bf7f233485544.jpg"
                alt="地域清掃活動"
                className="w-full h-48 object-cover rounded-lg shadow-md"
              />
              <img 
                src="https://readdy.ai/api/search-image?query=Local%20community%20festival%20with%20families%20enjoying%20outdoor%20event%2C%20colorful%20banners%20and%20booths%2C%20people%20of%20all%20ages%20participating%20in%20traditional%20Japanese%20community%20celebration%2C%20warm%20atmosphere&width=300&height=200&seq=community-2&orientation=landscape"
                alt="地域イベント参加"
                className="w-full h-48 object-cover rounded-lg shadow-md"
              />
              <img 
                src="https://readdy.ai/api/search-image?query=Emergency%20preparedness%20drill%20in%20Japanese%20neighborhood%2C%20residents%20and%20local%20business%20people%20practicing%20safety%20procedures%2C%20organized%20community%20response%20training%2C%20professional%20coordination&width=300&height=200&seq=community-3&orientation=landscape"
                alt="防災訓練"
                className="w-full h-48 object-cover rounded-lg shadow-md"
              />
              <img 
                src="https://readdy.ai/api/search-image?query=Local%20school%20children%20learning%20about%20community%20and%20real%20estate%20from%20business%20professionals%2C%20educational%20workshop%20setting%2C%20interactive%20learning%20environment%20with%20smiling%20participants&width=300&height=200&seq=community-4&orientation=landscape"
                alt="教育支援活動"
                className="w-full h-48 object-cover rounded-lg shadow-md"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CommunitySection;
